
const PathFromURL = {
  getPathURL() {
    let path = window.location.pathname;
    return path.replace(/^\/|\/$/g, '');
  },
};

export default PathFromURL;
